import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import SuccessAlert from "./../child/Alert/SuccessAlert";
import DengerAlert from "./../child/Alert/DengerAlert";

const ResetPasswordLayer = () => {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      navigate("/dashboard");
    }
    document.body.classList.add("signin-page");
    return () => {
      document.body.classList.remove("signin-page");
    };
  }, [navigate]);

  const togglePasswordVisibility = () => setPasswordVisible(prev => !prev);
  const toggleConfirmPasswordVisibility = () => setConfirmPasswordVisible(prev => !prev);
  const validateInputs = () => {
    const newErrors = {};
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!newPassword) {
      newErrors.newPassword = "New password is required";
    } else if (!passwordRegex.test(newPassword)) {
      newErrors.newPassword =
        "Password must be at least 8 characters long, include an uppercase letter, a lowercase letter, and a number";
    }
    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm password is required";
    } else if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = "The new password and confirm password must match.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleResetPass = async (e) => {
    e.preventDefault();
    if (!validateInputs()) return;
    setLoading(true);
    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/resetpassword`;
    try {
      const response = await fetch(API_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id:localStorage.getItem("adminId"),
          new_password: newPassword,
          confirm_password: confirmPassword,
        }),
      });

      if (!response.ok) {
        throw new Error("Incorrect password. Please check your credentials and try again.");
      }
      const data = await response.json();
      localStorage.setItem("email", email);
      setSuccessMessage("Your password has been successfully updated.");
      setTimeout(() => {
        setSuccessMessage("");
        navigate("/sign-in");
      }, 3000);
    } catch (error) {
      setErrorMessage(error.message);
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="auth bg-base d-flex flex-wrap">
      {successMessage && <SuccessAlert message={successMessage} onClose={() => setSuccessMessage("")} />}
      {errorMessage && <DengerAlert message={errorMessage} onClose={() => setErrorMessage("")} />}

      <div className="auth-left d-lg-block d-none">
        <div className="d-flex align-items-center flex-column h-100 justify-content-center">
          <img
            src={`${process.env.REACT_APP_PUBLIC_UR}/assets/images/auth/forgotPass.png`}
            alt="Auth"
          />
        </div>
      </div>

      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100">
          <div>
            <img src={`${process.env.REACT_APP_PUBLIC_UR}/assets/images/logo.png`} alt="Logo" />
            <h4 className="mb-12">Reset Password</h4>
          </div>

          <form onSubmit={handleResetPass}>
     

            <div className="mb-20">
              <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                New Password <span className="text-danger-600">*</span>
              </label>
              <div className="position-relative">
                <input
                  type={passwordVisible ? "text" : "password"}
                  className="form-control"
                  placeholder="Enter New Password"
                  maxLength="20"
                  value={newPassword}
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                    setErrors((prev) => ({ ...prev, newPassword: "" }));
                  }}
                />
                <span
                  className={`toggle-password ${
                    passwordVisible ? "ri-eye-off-line" : "ri-eye-line"
                  } cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                  onClick={togglePasswordVisibility}
                ></span>
              </div>
              {errors.newPassword && <p className="text-danger mt-1">{errors.newPassword}</p>}
            </div>

            <div className="mb-20">
              <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                Confirm Password <span className="text-danger-600">*</span>
              </label>
              <div className="position-relative">
                <input
                  type={confirmPasswordVisible ? "text" : "password"}
                  className="form-control"
                  placeholder="Enter Confirm Password"
                  maxLength="20"
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                    setErrors((prev) => ({ ...prev, confirmPassword: "" }));
                  }}
                />
                <span
                  className={`toggle-password ${
                    confirmPasswordVisible ? "ri-eye-off-line" : "ri-eye-line"
                  } cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                  onClick={toggleConfirmPasswordVisibility}
                ></span>
              </div>
              {errors.confirmPassword && <p className="text-danger mt-1">{errors.confirmPassword}</p>}
            </div>

            <button
              type="submit"
              className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
              disabled={loading}
            >
              {loading ? "Submit..." : "Submit"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ResetPasswordLayer;
